import { ImageWrapper } from '../../common/wrappers/ImageWrapper';
import { ZdarGameHint } from '../../../configuration/games/zdar-escape-game/zdarEscapeGameContentConfiguration';
import { useState } from 'react';
import Button from '../../common/buttons/Button';
import mark from '../../../assets/images/common/question.svg';
import parse from 'html-react-parser';

type Props = {
    id: number;
    hint: ZdarGameHint;
    selectHint: () => void;
    showSolution: () => void;
};

export default function ZdarHint({ id, hint, selectHint, showSolution }: Props) {
    const [open, setOpen] = useState(false);

    const click = () => {
        setOpen(true);
        selectHint();
    };
    const clickSolution = () => {
        setOpen(true);
        showSolution();
    };

    if (hint.text && hint.solution) {
        return (
            <div className={!open || hint.text ? 'zdar-hint zdar-hint--solution zdar-hint--closed' : 'zdar-hint'}>
                {(!open || hint.text) && (
                    <ImageWrapper
                        className="zdar-hint-label"
                        src={mark}
                        alt="Nápověda"
                        width={25}
                        height={25}
                        allowLightbox={false}
                    />
                )}
                {!open && (
                    <Button onClick={clickSolution} className="primary-button">
                        {'Zobrazit řešení'}
                    </Button>
                )}
                {open && <div className="zdar-hint-text">{hint.text}</div>}
            </div>
        );
    }
    if (hint.text && hint.image) {
        return (
            <div className={!open ? 'zdar-hint zdar-hint--closed' : undefined}>
                {!open && (
                    <ImageWrapper
                        className="zdar-hint-label"
                        src={mark}
                        alt="Nápověda"
                        width={25}
                        height={25}
                        allowLightbox={false}
                    />
                )}
                {!open && (
                    <Button onClick={click} className="primary-button">
                        {'Zobrazit ' + (id + 1) + '. nápovědu'}
                    </Button>
                )}
                {open && <div className="zdar-hint-text zdar-hint-text-padded">{hint.text}</div>}
                {open && (
                    <div className="zdar-hint-image">
                        <ImageWrapper src={hint.image} alt="hint" allowLightbox={false} />
                    </div>
                )}
            </div>
        );
    }
    return (
        <div className={!open || hint.text ? 'zdar-hint zdar-hint--closed' : 'zdar-hint'}>
            {(!open || hint.text) && (
                <ImageWrapper
                    className="zdar-hint-label"
                    src={mark}
                    alt="Nápověda"
                    width={25}
                    height={25}
                    allowLightbox={false}
                />
            )}
            {!open && (
                <Button onClick={click} className="primary-button">
                    {'Zobrazit ' + (id + 1) + '. nápovědu'}
                </Button>
            )}
            {open && hint.text && <div className="zdar-hint-text">{hint.text}</div>}
            {open && hint.html && <>{parse(hint.html)}</>}
            {open && hint.image && (
                <div className="zdar-hint-image">
                    <ImageWrapper src={hint.image} alt="hint" allowLightbox={false} />
                </div>
            )}
        </div>
    );
}
